module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1600-6f4356f7d7264440e6588252a2c0daf6.webp";